module.exports = __webpack_public_path__ + "img/attach-file-icon.76af5570.svg";